import React, { useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';

import LogoLPG from '../../assets/images/logo-lpg.png';
import LogoWLPGA from '../../assets/images/logo-wlpga.png';
import ImagenCamion from '../../assets/images/camiongranel_ruta.jpg';

import ImageSkeleton from '../../components/Skeleton/ImageSkeleton';

import { getSolucionesEnergeticas, getIndustrias } from '../../config/services/strapi/strapi';

import { Industria, Solucion } from '../../interfaces/types';

function Soluciones() {
  const [soluciones, setSoluciones] = useState<Solucion[]>([]);
  const [industrias, setIndustrias] = useState<Industria[]>([]);

  const [cargando, setCargando] = useState({
    soluciones: true,
    industrias: true,
  });

  useEffect(() => {
    const fetchSoluciones = async () => {
      const rawSoluciones = await getSolucionesEnergeticas();
      const mappedSoluciones = rawSoluciones.map((solucion: any) => ({
        id: solucion.id,
        beneficios: solucion.beneficios,
        caracteristicas: solucion.caracteristicas,
        descripcion: solucion.descripcion,
        externo: solucion.externo,
        icono: solucion.icono,
        imagenBeneficios: solucion.imagen_beneficios,
        imagenIndustria: solucion.imagen_industria,
        imagenProyectos: solucion.imagen_proyectos,
        industrias: solucion.industrias,
        nombre: solucion.nombre,
        portada: solucion.portada,
        url: solucion.url,
      }));

      setSoluciones(mappedSoluciones);
      setCargando(prev => ({ ...prev, soluciones: false }));
    };

    const fetchIndustrias = async () => {
      const rawIndustrias = await getIndustrias();
      const mappedIndustrias: Industria[] = rawIndustrias.map((industria: any) => ({
        id: industria.id,
        nombre: industria.nombre,
        nombreIndustria: industria.nombre_industria,
        logo: {
          url: industria.logo?.url
        },
        icono: {
          url: industria.icono?.url
        },
        descripcion: industria.descripcion,
        beneficios: industria.beneficios,
        slug: `/industrias/${industria.slug}`,
        banner: {
          url: industria.banner?.url
        },
        imagenBeneficios: {
          url: industria.imagenBeneficios?.url
        },
        soluciones: []
      }));

      setIndustrias(mappedIndustrias);
      setCargando(prev => ({ ...prev, industrias: false }));
    };

    fetchSoluciones();
    fetchIndustrias();
  }, []);

  return (
    <main>
      {/* Hero */}
      <section className='max-w-full overflow-x-hidden'>
        <div className='flex flex-col lg:flex-row lg:flex-row-reverse lg:justify-between lg:items-center lg:gap-8 lg:pl-[108px] lg:pb-6'>
          <figure className='!m-0 w-full'>
            <img className='w-full' src={ImagenCamion} alt="" />
          </figure>
          <h2 className='w-full text-left !text-[20.4px] md:!text-[27.2px] lg:!text-[34px] 2xl:!text-[48px] leading-6 md:leading-8 lg:leading-[40.8px] 2xl:leading-[57.6px] text-[var(--text-color-primary)] font-bold pl-[15px] lg:pl-0 pr-[20px] pt-[34px] pb-[48px]'>
            Tenemos soluciones funcionales para las distintas industrias
          </h2>
        </div>
      </section>
      {/* Descripción */}
      <section className='max-w-full overflow-x-hidden'>
        <div className='bg-[var(--background-color-primary)] lg:px-[108px] pt-[51px] pb-12 border-b-[6px] border-[var(--border-color-tertiary)] flex flex-col md:flex-row md:items-center grid grid-cols-2 gap-2'>
          <p className='col-span-2 md:col-span-1 text-left !text-white pl-[15px] lg:pl-0 pr-[38px] md:pr-[40px] 2xl:pr-[65px] pb-10 text-[27.2px] lg:text-[37px] 2xl:text-[48px] !leading-[29.92px] lg:!leading-[37.4px] 2xl:!leading-[57.6px] lg:mb-[17px]'>Conoce las propuestas energéticas que mejorarán tu empresa</p>
          <div className="col-span-2 md:col-span-1 grid grid-cols-12 gap-x-4 gap-y-2 lg:gap-x-8 lg:gap-y-1 items-start pl-[15px] pr-[20px]">
            {
              cargando.industrias ? 

                Array.from({ length: 8 }).map((_, index) => (
                  <div className="col-span-6 md:col-span-4 flex justify-center p-2">
                    <ImageSkeleton className="rounded-full overflow-hidden w-[71px] h-[71px]" />
                  </div>
                ))
                
                :

                industrias.map((industria) => (
                  <div key={`industria-${industria.id}`} className="flex justify-center items-center px-[10px] pb-[25px] xl:pb-[56px] col-span-6 md:col-span-4">
                    <NavLink to={industria.slug} className="w-full h-full flex flex-col justify-center items-center !text-white">
                      <figure className='min-w-[71px] xl:min-w-[100px] max-w-[71px] xl:max-w-[100px] min-h-[71px] xl:min-h-[100px] max-h-[71px] xl:max-h-[100px] !p-4 !rounded-full !border-[2px] !border-white flex justify-center items-center !mb-2 !mt-0'>
                        <img className='min-w-[40px] xl:min-w-[50px] max-w-[40px] xl:max-w-[50px] min-h-[40px] xl:min-h-[50px] max-h-[40px] xl:max-h-[50px] invert-100 brightness-0' src={industria.icono?.url} alt="" />
                      </figure>
                      <p className='font-semibold text-center !leading-[18.7px] !text-[15.6px]'>{industria.nombre}</p>
                    </NavLink>
                  </div>
                ))
            }
          </div>
        </div>
      </section>
      {/* Soluciones */}
      <section className='max-w-full overflow-x-hidden pt-12 px-[15px]'>
        <div className="mb-10 lg:px-[108px]">
          <h2 className='text-[var(--text-color-primary)] text-[25.5px] md:text-[34px] 2xl:text-[48px] leading-8 2xl:leading-[40.8px]'>Soluciones Energéticas Gasco</h2>
          <p className='text-sm 2xl:text-lg text-[#212529] mb-10'>Encuentra información acerca de cada una de las soluciones energéticas de Gasco</p>
          <div className="grid grid-cols-12 gap-y-8 md:gap-4">
            {
              cargando.soluciones ?

                Array.from({ length: 16 }).map((_, index) => (
                  <ImageSkeleton className="col-span-12 md:col-span-3 rounded-3xl overflow-hidden w-full h-[520px] md:h-[280px] xl:h-[400px] 2xl:h-[620px]" />
                ))

                :

                soluciones.map((solucion, index) => (
                  <div key={index} className="col-span-12 md:col-span-3">
                    {
                      solucion.externo ?

                        <a href={solucion.url} target="_blank" rel="noopener noreferrer" className='relative'>
                          <img className='w-full h-full object-cover !rounded-xl' src={solucion.portada?.url} alt="" />
                          <div className="absolute bottom-9 left-4 pr-4">
                            <p className='text-white text-[18px] 2xl:!text-[28px] mb-4'>{solucion.nombre}</p>
                            <span className="text-white rounded-full border-2 border-white w-6 xl:w-10 h-6 xl:h-10 inline-flex justify-center items-center">
                              <i className="fas fa-chevron-right text-[8px] xl:text-[12px] font-[300]"></i>
                            </span>
                          </div>
                        </a>

                        :

                        <NavLink to={`/soluciones/${solucion.url}`} className="relative block w-full h-full overflow-hidden">
                          <img className='w-full h-full object-cover !rounded-xl' src={solucion.portada?.url} alt="" />
                          <div className="absolute bottom-9 left-4 pr-4">
                            <p className='text-white text-[18px] 2xl:!text-[28px] mb-4'>{solucion.nombre}</p>
                            <span className="text-white rounded-full border-2 border-white w-6 2xl:w-10 h-6 2xl:h-10 inline-flex justify-center items-center">
                              <i className="fas fa-chevron-right text-[8px] 2xl:text-[12px] font-[300]"></i>
                            </span>
                          </div>
                        </NavLink>
                    }
                  </div>
                ))
            }
          </div>
        </div>
      </section>
      {/* Miembros WLPGA */}
      <section className='max-w-full overflow-x-hidden py-[68px] lg:py-[120px] px-[15px] lg:px-[102px] lg:pb-4'>
        <div className="lg:flex lg:items-center w-full gap-24 xl:gap-32 2xl:gap-0">
          <div className="mb-10 lg:w-full xl:w-2/3">
            <h3 className='text-[var(--text-color-primary)] text-[34px] 2xl:text-[48px] leading-10 2xl:leading-[57.6px] !mt-0 !mb-[17px]'>Miembros de<br></br> WLPGA</h3>
            <p className='text-sm lg:text-[14.45px] 2xl:text-[20.4px] text-[var(--text-color-primary)] mb-10 mt-6 leading-5 2xl:leading-[28.56px] lg:text-left !my-0'>
              Gasco es parte de la Asociación Mundial de GL (WLPGA), agrupación mundial de empresas de la industria y organizaciones vinculadas al sector energético, es la voz autorizada de la industria global del GLP que representa toda la cadena de valor del GLP.
            </p>
          </div>
          <div className="flex flex-col md:flex-row justify-center items-center gap-4 lg:gap-6 px-16 md:px-64 lg:px-28 xl:pr-92 xl:pl-48 2xl:pl-10 lg:w-full">
            <img src={LogoLPG} alt="" />
            <img src={LogoWLPGA} alt="" />
          </div>
        </div>
      </section>
    </main>
  )
}

export default Soluciones